import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { FloatingComponentService } from './floating-component.service';
import { AiAssistantTalkPanelComponent } from '../../components/floating-panel/ai-assistant-talk-panel.component';
import { AiAssistant } from '../interfaces/ai-assistant.interface';
import { DEFAULT_AVATAR_SVG_ICON } from '../ai-assistant.constants';
import { WebRTCCallService } from './webrtc-call.service';
import { aiAssistantAssetUrl } from '../pipes/ai-assistant-asset-url.pipe';

export interface TalkPanelConfig {
  assistantName?: string;
  assistantAvatarUrl?: string;
  assistantIcon?: string;
  assistantId?: string;
  jobTitle?: string;
  ringColor?: string;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  offsetX?: number;
  offsetY?: number;
}

@Injectable({
  providedIn: 'root',
})
export class AiTalkPanelService {
  private readonly floatingService = inject(FloatingComponentService);
  private readonly webrtcCallService = inject(WebRTCCallService);
  private readonly document = inject(DOCUMENT);

  openTalkPanel(config: TalkPanelConfig = {}): void {
    const defaultConfig: TalkPanelConfig = {
      assistantName: 'AI Assistant',
      assistantIcon: 'smart_toy',
      jobTitle: 'Voice Assistant',
      position: 'top-right',
      offsetX: 20,
      offsetY: 20,
    };

    const finalConfig = { ...defaultConfig, ...config };

    this.floatingService.open({
      component: AiAssistantTalkPanelComponent,
      data: { config: finalConfig },
      position: finalConfig.position,
      offsetX: finalConfig.offsetX,
      offsetY: finalConfig.offsetY,
      width: '320px',
      maxWidth: '320px',
      panelClass: 'ai-talk-panel',
    });
  }

  openForAssistant(params: { accountGroupId: string | null; partnerId: string | null; assistant: AiAssistant }): void {
    const { accountGroupId, partnerId, assistant } = params;

    this.webrtcCallService.setNamespaces(accountGroupId, partnerId);

    const iconName = assistant.decoration?.defaultAvatarIcon || DEFAULT_AVATAR_SVG_ICON;
    const iconUrl = aiAssistantAssetUrl(iconName, this.document);
    this.openTalkPanel({
      assistantId: assistant.assistant.id,
      assistantName: assistant.assistant.name,
      assistantAvatarUrl: assistant.assistant.avatarUrl || assistant.decoration?.avatarIconUrl || iconUrl || undefined,
      assistantIcon: iconUrl ? undefined : iconName,
      jobTitle: assistant.subtitleKey || '',
      ringColor: assistant.decoration?.gradientColor,
    });
  }

  closeTalkPanel(): void {
    this.floatingService.close();
  }
}
